/**
 * 人员管理
 */
import request from "@/utils/request";


export function sexList() {
  return [
    {id: 1, label: "男"},
    {id: 2, label: "女"}
  ]
}

/**
 * 查询人员列表
 */
export function list(param) {
  return request({
    url: "/base/psndoc/list",
    method: "post",
    data: param
  });
}

/**
 * 根据PK查询单据
 */
export function get(pk) {
  return request({
    url: "/base/psndoc/get/" + pk,
    method: "get"
  });
}

/**
 * 保存单据
 */
export function save(data) {
  return request({
    url: "/base/psndoc/save",
    method: "post",
    data: data
  });
}

/**
 * 停用
 */
export function seal(pk) {
  return request({
    url: "/base/psndoc/seal/" + pk,
    method: "get"
  });
}

/**
 * 启用
 */
export function unseal(pk) {
  return request({
    url: "/base/psndoc/unseal/" + pk,
    method: "get"
  });
}

/**
 * 修改密码
 */
export function updatePsndoc(data) {
  return request({
    url: "/base/psndoc/updatePsndoc",
    method: "post",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/base/psndoc.js